var TerrificOnInit = /** @class */ (function () {
    function TerrificOnInit(renderer) {
        this.renderer = renderer;
        this.terrificInitExecuted = false;
    }
    TerrificOnInit.prototype.ngOnInit = function () {
        this.terrificUnlisten = this.renderer.listen('document', 'terrificAvailable', this.tOninit.bind(this));
        this.tOninit();
    };
    TerrificOnInit.prototype.tOninit = function () {
        var _this = this;
        this.terrific = window['Terrific'];
        if (this.terrific && !this.terrificInitExecuted) {
            this.terrificInitExecuted = true;
            this.terrificUnlisten();
            this.terrific.waitForBootstrap().then(function () { return _this.onTerrificBootstrap(); });
        }
    };
    return TerrificOnInit;
}());
export { TerrificOnInit };
//# sourceMappingURL=terrific-on-init.js.map